function Articles() {

    return (
      <>
        <div className="ml-10 mt-5">
          <div className="flex">
            <div className="w-1/6 text-center"></div>

            <div className="w-full">

                <div className="flex">
                    <div className="w-full">
                        <p><a href="https://www.kms.or.kr/board/list.html?code=news" target='_blank'>M. Kim, “Topological quantum field theory.” (in Korean)</a></p>
                        <p>Newsletter of Korean Mathematical Society (2024)</p>
                    </div>
                </div>

                <div className="flex mt-2 ">
                    <div className="w-full">
                        <p><a href="https://horizon.kias.re.kr/28327/" target='_blank'>M. Kim, “Division and homotopy cardinality of groupoids.” (in Korean)</a></p>
                        <p>HORIZON: a web-magazine published in KIAS (2024)</p>
                    </div>
                </div>

            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default Articles;